import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClaimApiV2 } from '../../../../hooks';
import { PetCard } from '../../../insurance/multiplePets/PetCard';

import { PET_GENDER } from '../../../../constants';

import './PetSelector.css';

const PetSelector = ({
  onPetItemPress = () => { },
  pets = [],
  selectedPet = null,
}) => {
  const { t } = useTranslation('fileClaimbot');

  const getPetGenderDisplay = (genderValue) => {
    // Remove this with PetCloudClaimsApiV2 FF
    const isClaimApiV2 = useClaimApiV2();

    if (!isClaimApiV2) {
      return genderValue === PET_GENDER.MALE
        ? t('petGenders.male') : t('petGenders.female');
    }

    return genderValue;
  };

  return (
    <div className="Pet-selector-container">
      {pets.map((pet) => (
        <PetCard
          key={`${pet.Id}-${pet.Name}`}
          age={pet.Age}
          breed={pet.Breed}
          classContainer={pet === selectedPet
            ? 'Pet-selector-pet-selected'
            : 'Pet-selector-pet-non-selected'}
          gender={getPetGenderDisplay(pet.Gender)}
          name={pet.Name}
          onClick={onPetItemPress(pet)}
          picture={pet.PictureUrl}
          weight={pet.Weight}
        />
      ))}
    </div>
  );
};

export { PetSelector };
